import { type Dispatch, type SetStateAction, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import {
  type ClientSessionCustomerData,
  type UserOrderResponseV2,
  type UserOrderResponseWithFlags,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

export interface SubOrderProductListProps {
  hashedToken?: string
  isERx?: boolean
  isSelected?: boolean
  itemName: string
  itemQuantity?: string
  pzn?: string
  subOrderId?: string
}

export const useDirectContactFormOrderSelection = (
  prefilledSubOrder?: UserSubOrderV2,
): {
  orderSelectionDialogTitle: string
  productList: SubOrderProductListProps[]
  selectedOrder: (UserOrderResponseWithFlags | UserOrderResponseV2) | null
  setOrderSelectionDialogTitle: Dispatch<SetStateAction<string>>
  setProductList: Dispatch<SetStateAction<SubOrderProductListProps[]>>
  setSelectedOrder: Dispatch<
    SetStateAction<(UserOrderResponseWithFlags | UserOrderResponseV2) | null>
  >
  setSelectedSubOrder: Dispatch<SetStateAction<UserSubOrderV2 | null>>
  setSubject: Dispatch<SetStateAction<string>>
  setSubOrderNumber: Dispatch<SetStateAction<string>>
  setUserData: Dispatch<SetStateAction<ClientSessionCustomerData>>
  subject: string
  subOrderNumber: string
  userData: ClientSessionCustomerData
} => {
  const intl = useIntl()

  const [productList, setProductList] = useState<SubOrderProductListProps[]>([])
  const [userData, setUserData] = useState<ClientSessionCustomerData>({})
  const [subject, setSubject] = useState('')
  const [orderSelectionDialogTitle, setOrderSelectionDialogTitle] = useState(
    intl.formatMessage({ id: 'direct.contact.form.select.order' }),
  )
  const [subOrderNumber, setSubOrderNumber] = useState<string>(
    prefilledSubOrder?.subOrderId ?? '',
  )

  const [selectedSubOrder, setSelectedSubOrder] =
    useState<UserSubOrderV2 | null>(prefilledSubOrder ?? null)

  const [selectedOrder, setSelectedOrder] = useState<
    (UserOrderResponseWithFlags | UserOrderResponseV2) | null
  >(null)

  return useMemo(
    () => ({
      orderSelectionDialogTitle,
      productList,
      selectedOrder,
      selectedSubOrder,
      setOrderSelectionDialogTitle,
      setProductList,
      setSelectedOrder,
      setSelectedSubOrder,
      setSubject,
      setSubOrderNumber,
      setUserData,
      subject,
      subOrderNumber,
      userData,
    }),
    [
      orderSelectionDialogTitle,
      productList,
      selectedOrder,
      setOrderSelectionDialogTitle,
      setProductList,
      setSelectedOrder,
      selectedSubOrder,
      setSelectedSubOrder,
      setSubject,
      setSubOrderNumber,
      setUserData,
      subject,
      subOrderNumber,
      userData,
    ],
  )
}
